import { flavorAtlas } from "@/mocks/flavorAtlas";
import SectionHeading from "./SectionHeading";

export default function FlavorGuide() {
  return (
    <section
      id="flavor"
      className="w-full border-y border-background-200 bg-background-100"
    >
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="风味图鉴"
          title="六种风味走向，帮你快速对号入座"
          desc="零食的差别往往在风味主调上。下图把盲盒里常见的风味归成六类，并列出对应的代表零食，方便你判断自己偏爱哪一种。"
        />

        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {flavorAtlas.map((flavor) => (
            <article
              key={flavor.id}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${flavor.icon} text-xl`} />
                </span>
                <h3 className="font-heading text-lg text-foreground-950">
                  {flavor.name}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                {flavor.desc}
              </p>
              <p className="mt-3 flex items-start gap-2 text-xs leading-relaxed text-foreground-500">
                <span className="flex h-4 w-4 shrink-0 items-center justify-center">
                  <i className="ri-restaurant-2-line text-primary-600" />
                </span>
                代表：{flavor.examples}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}